import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { Location } from '@angular/common';
import { AuthPathsService } from '@core/multi-tenant-auth/auth-paths.service';

export const ensureInstitutionPortalGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const location = inject(Location);
  const authPaths = inject(AuthPathsService);

  // Never match Institution Portal routes when on the auth hub origin.
  if (authPaths.isCurrentOriginAuthHub()) {
    return false;
  }

  const portal = authService.getCurrentPortalType();
  return location.path() === '/privacy-policy' ? portal === 'institution' || portal === 'student' : portal === 'institution';
};
